//#region Styles
import {
    Part, Row, TitleSection2,
    ResumeSection, 
    Column
} from "components/styles";
//#endregion
//#region Components
import CustomButton from "components/CustomButton/CustomButton";
//#endregion
//#region Icons
import PenIcon from "icons/PenIcon";
import DataField from "views/components/Detail/DataField/DataField";
import LocationDataField from "views/components/Detail/LocationDataField/LocationDataField";
import DurationDataRender from "views/components/Detail/DurationDataRender/DurationDataRender";
import ListDataField from "views/components/Detail/ListDataField/ListDataField";
//#endregion

const ResumeStep2 = ({
    data,
    dataRelatedToForm: {
        locations,
        inscriptionTypes,
        environmentTypeList
    },
    toStep2,
    isDetailEvent
}) => {
    const getDataPart1 = () => {
        const {
            title, description, duration,
            standOutAcadReinforce, locationId, 
            zoomInscriptionTypeId, 
            place
        } = data;
        const location = locations.find(({ id }) => id === locationId);
        const dataPart = [
            [
                { 
                    field: "Título:", 
                    description: title 
                },
                { 
                    field: "Descripción (opcional):", 
                    description: description || "- Por completar -"
                },
                { 
                    field: "¿Es destacado?:", 
                    description: standOutAcadReinforce ? "Sí" : "No"
                },
                {
                    field: "Duración",
                    render: (
                        <DurationDataRender duration={duration}/>
                    )
                }
            ],
            [
                { 
                    field: "Ubicación:", 
                    render: (
                        <LocationDataField location={location}/>
                    ) 
                }
            ]
        ];
        if (locationId === 1) {
            dataPart[1].push({
                field: "Modo de inscripción para el evento:", 
                description: inscriptionTypes.find(({ id }) => id === zoomInscriptionTypeId)?.name,
                mini: true
            });
        }
        else if (locationId === 2) {
            const { campus, environmentTypeId, environment, otherEnvironment } = place;
            dataPart[1].push({
                field: "Campus:",
                render: <ListDataField data={[campus?.name || "-"]}/>
            });
            if (environment) {
                dataPart[1].push({
                    render: (
                        <Column width="100%">
                            <Row columnGap="38px">
                                <DataField
                                    field="Ambiente:"
                                    description={environment.environmentCode}/>
                                <DataField
                                    field="Tipo de ambiente:"
                                    description={environmentTypeList.find(({ id }) => id === environmentTypeId)?.name || "-"}/>
                            </Row>
                            <DataField
                                field="Dirección:"
                                description={environment.address || "-"}/>
                            <Row columnGap="80px">
                                <DataField
                                    field="Piso:"
                                    description={environment.floor || "-"}/>
                                <DataField
                                    field="Capacidad:"
                                    description={environment.capacity || "-"}/>
                            </Row>
                        </Column>
                    )
                });
            }
            else if (otherEnvironment) {
                dataPart[1].push({
                    render: (
                        <Column>
                            <DataField
                                field="Otro ambiente:"
                                description={otherEnvironment.envName}/>
                            <DataField
                                field="Dirección:"
                                description={otherEnvironment.address}/>
                            <Row width="100%">
                                <DataField
                                    field="Piso:"
                                    description={otherEnvironment.floor}/>
                                <DataField
                                    field="Capacidad:"
                                    description={otherEnvironment.capacity}/>
                            </Row>
                        </Column>
                    )
                });
            }
        }
        return dataPart;
    }
    return (
        <Part>
            <Row>
                <TitleSection2>Información, duración y ubicación</TitleSection2>
                {!isDetailEvent && (
                    <CustomButton
                        variant="quintinary"
                        text="Editar sección"
                        icon={<PenIcon/>}
                        onClick={toStep2}/>
                )}
            </Row>
            <ResumeSection>
                <Part direction="row">
                    {data && getDataPart1().map((row, idx1) => {
                        return (
                            <Column 
                                key={idx1} 
                                gap="20px" 
                                width="45%">
                                {row.map((item, idx2) => {
                                        return (
                                            <DataField 
                                                key={idx2}
                                                {...item}/>
                                        );
                                    }
                                )}
                            </Column>
                        );
                    })}
                </Part>
            </ResumeSection>
        </Part>
    );
}

export default ResumeStep2;